.categories {
  padding: 84px 0;
}

.led {
  border-top: 3px solid var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
}

.lrow {
  position: relative;
  display: grid;
  grid-template-columns: 34px 1fr auto;
  gap: 18px;
  align-items: baseline;
  padding: 16px 14px;
  border-bottom: 1px solid var(--color-primary-sand-200); /* PRIMARY_SAND_200 */
  overflow: hidden;
}

.lrow__bar {
  position: absolute;
  inset: 0 auto 0 0;
  background: var(--color-primary-blue-100); /* PRIMARY_BLUE_100 */
  z-index: 0;
  transition: background 0.2s cubic-bezier(0.04, 0.4, 0.5, 0.95);
}

.lrow:hover .lrow__bar {
  background: var(--color-complementary-yellow); /* COMPLEMENTARY_YELLOW */
}

/* The whole row is the link target, so it carries no link colour of its own; the name picks up
   the underline on hover to say it is clickable. */
.lrowLink {
  color: inherit;
  text-decoration: none;
  cursor: pointer;
}

.lrowLink:hover .lrow__name,
.lrowLink:focus-visible .lrow__name {
  text-decoration: underline;
}

.lrowLink:focus-visible {
  outline: 2px solid var(--color-primary-blue-500); /* PRIMARY_BLUE_500 */
  outline-offset: -2px;
}

.lrow > *:not(.lrow__bar) {
  position: relative;
  z-index: 1;
}

.lrow__n {
  font-size: 13px; /* HEADING_5XS */
  font-weight: 800;
  color: var(--color-text-tertiary); /* TEXT_TERTIARY */
  font-variant-numeric: tabular-nums;
}

.lrow__name {
  font-size: 18px; /* COPY_L */
  font-weight: 600;
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
}

.lrow__val {
  font-family: var(--plume-font-display, sofia-pro, sans-serif);
  font-size: 19px; /* HEADING_XS */
  font-weight: 900;
  letter-spacing: -0.01em;
  color: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.led__note {
  margin: 20px 0 0;
  font-size: 13px; /* HEADING_5XS */
  color: var(--color-text-tertiary); /* TEXT_TERTIARY */
}

@media (max-width: 768px) {
  .categories {
    padding: 56px 0;
  }
}
